import script from "./HomepageSaintluc.vue?vue&type=script&setup=true&lang=js"
export * from "./HomepageSaintluc.vue?vue&type=script&setup=true&lang=js"

import "./HomepageSaintluc.vue?vue&type=style&index=0&id=4aedd90e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4aedd90e"]])

export default __exports__